// action - customization reducer
export const SET_Search = '@customization/SET_Search';
export const SET_MENU = '@customization/SET_MENU';
export const MENU_TOGGLE = '@customization/MENU_TOGGLE';
export const MENU_OPEN = '@customization/MENU_OPEN';
export const SET_FONT_FAMILY = '@customization/SET_FONT_FAMILY';
export const SET_BORDER_RADIUS = '@customization/SET_BORDER_RADIUS';
export const SET_THEME_MODE = '@customization/SET_THEME_MODE';
export const Add_Cart = '@cart/Add_Cart';
export const Add_Customer = '@cart/Add_Customer';
export const Add_PaymentType = '@cart/Add_PaymentType';
export const Add_Billing = '@cart/Add_Billing';
export const Add_Wallet = '@cart/Add_Wallet';
export const Add_Reference = '@cart/Add_Reference';
export const Add_Premiums = '@cart/Add_Premiums';
export const Add_Images = '@cart/Add_Images';
export const Add_CartPreorder = '@cartPreorder/Add_CartPreorder';
export const Add_CustomerPreorder = '@cartPreorder/Add_CustomerPreorder';
export const Add_PaymentTypePreorder = '@cartPreorder/Add_PaymentTypePreorder';
export const Add_BillingPreorder = '@cartPreorder/Add_BillingPreorder';
export const Add_WalletPreorder = '@cartPreorder/Add_WalletPreorder';
export const Add_ReferencePreorder = '@cartPreorder/Add_ReferencePreorder';
export const Add_CartCustomer = '@cartCustomer/Add_CartCustomer';
export const Add_CustomerCustomer = '@cartCustomer/Add_CustomerCustomer';
export const Add_PaymentTypeCustomer = '@cartCustomer/Add_PaymentTypeCustomer';
export const Add_BillingCustomer = '@cartCustomer/Add_BillingCustomer';
export const Add_WalletCustomer = '@cartCustomer/Add_WalletCustomer';
export const Add_ReferenceCustomer = '@cartCustomer/Add_ReferenceCustomer';
export const Add_ImagesCustomer = '@cartCustomer/Add_ImagesCustomer';
